import React from "react";
import FooterPagination from "../../../common/FooterPagination";

const OnlinePendingLogsFooterView = (props) => {
  const {
    pendingAppointments,
    currentPage,
    totalCount,
    pageSize,
    onPageChange,
  } = props;

  return (
    <>
      {pendingAppointments?.length > 0 && (
        <div>
          <FooterPagination
            currentPage={currentPage}
            totalCount={totalCount}
            pageSize={pageSize}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </>
  );
};

export default OnlinePendingLogsFooterView;
